module.exports = __webpack_public_path__ + "img/laboratorio2_16-9_960.04c61d0e.webp";